<script>
import { Line } from 'vue-chartjs'
import { get } from 'vuex-pathify'

export default {
  extends: Line,
  computed: {
    monthsLabel: get('dashboard/monthsLabel'),
    monthsData: get('dashboard/monthsData')
  },
  watch: {
    monthsData: {
      deep: true,
      handler() {
        this.render()
      }
    }
  },
  mounted() {
    this.render()
  },
  methods: {
    render() {
      const vm = this
      this.renderChart(
        {
          labels: [...this.monthsLabel],
          datasets: [
            {
              label: this.$t('Points'),
              data: [...this.monthsData],
              backgroundColor: 'transparent',
              borderColor: '#4287f5',
              pointBackgroundColor: '#f55742'
            }
          ]
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: vm.$t('My points')
          }
        }
      )
    }
  }
}
</script>
